import { Heading, Text } from '@pu/mpp-ui/components/typography';
import { useCSS } from '@pu/mpp-ui/hooks';

import './not-found.scss';

export const NotFound = () => {
  const css = useCSS('not-found');
  return (
    <section className={css()}>
      <div className={css('container')}>
        <Heading size="xl">¡Lo sentimos!</Heading>
        <Text size="md">No encontramos la página que buscabas.</Text>
      </div>
    </section>
  );
};
